import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const footerLinks = {
    explore: [{
      label: 'All Places',
      path: '/places'
    }, {
      label: 'Wildlife & Nature',
      path: '/wildlife-nature'
    }, {
      label: 'Culture & History',
      path: '/culture-history'
    }, {
      label: 'Shopping & Markets',
      path: '/shopping-markets'
    }, {
      label: 'Landmarks',
      path: '/landmarks'
    }],
    experience: [{
      label: 'Local Cuisine',
      path: '/cuisine'
    }, {
      label: 'Nightlife',
      path: '/nightlife'
    }, {
      label: 'Festivals & Events',
      path: '/festivals'
    }, {
      label: 'Experiences',
      path: '/experiences'
    }, {
      label: 'Local Insights',
      path: '/insights'
    }],
    discover: [{
      label: 'About Nairobi',
      path: '/about-nairobi'
    }, {
      label: 'Estates',
      path: '/neighborhoods'
    }, {
      label: 'Top Hotels',
      path: '/hotels'
    }],
    plan: [{
      label: 'Plan Your Visit',
      path: '/plan'
    }, {
      label: 'Economy & Innovation',
      path: '/economy-innovation'
    }]
  };
  return <footer className="bg-gray-900 text-white" data-id="element-54">
      <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20" data-id="element-55">
        {/* Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-16 mb-20" data-id="element-56">
          {/* Logo & About */}
          <div className="lg:col-span-1" data-id="element-57">
            <Link to="/" onClick={() => window.scrollTo(0, 0)} className="block mb-6 group" data-id="element-58">
              <div className="relative" data-id="element-59">
                <div className="text-lg font-light tracking-[0.3em] text-white uppercase" data-id="element-60">
                  Visit
                </div>
                <div className="text-2xl font-poppins text-white -mt-1" data-id="element-61">
                  Nairobi
                </div>
                <div className="absolute -bottom-1 left-0 w-full h-px bg-gradient-to-r from-amber-500 via-amber-400 to-transparent" data-id="element-62"></div>
              </div>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed font-light" data-id="element-63">
              Where elegance meets adventure in Africa's most distinguished
              capital.
            </p>
          </div>

          {/* Explore Links */}
          <div data-id="element-64">
            <h4 className="text-xs font-light text-gray-400 mb-6 uppercase tracking-widest" data-id="element-65">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-66">
              {footerLinks.explore.map(link => <li key={link.label} data-id="element-67">
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-300 hover:text-white transition-colors font-light" data-id="element-68">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Experience Links */}
          <div data-id="element-69">
            <h4 className="text-xs font-light text-gray-400 mb-6 uppercase tracking-widest" data-id="element-70">
              Experience
            </h4>
            <ul className="space-y-4" data-id="element-71">
              {footerLinks.experience.map(link => <li key={link.label} data-id="element-72">
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-300 hover:text-white transition-colors font-light" data-id="element-73">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Discover Links */}
          <div data-id="element-74">
            <h4 className="text-xs font-light text-gray-400 mb-6 uppercase tracking-widest" data-id="element-75">
              Discover
            </h4>
            <ul className="space-y-4" data-id="element-76">
              {footerLinks.discover.map(link => <li key={link.label} data-id="element-77">
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-300 hover:text-white transition-colors font-light" data-id="element-78">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Plan Links */}
          <div data-id="element-79">
            <h4 className="text-xs font-light text-gray-400 mb-6 uppercase tracking-widest" data-id="element-80">
              Plan
            </h4>
            <ul className="space-y-4" data-id="element-81">
              {footerLinks.plan.map(link => <li key={link.label} data-id="element-82">
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-300 hover:text-white transition-colors font-light" data-id="element-83">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-10 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-84">
          <p className="text-xs text-gray-500 font-light tracking-wider" data-id="element-85">
            © 2026 VISIT NAIROBI. ALL RIGHTS RESERVED.
          </p>
          <div className="flex gap-8" data-id="element-86">
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors font-light tracking-wider" data-id="element-87">
              PRIVACY
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors font-light tracking-wider" data-id="element-88">
              TERMS
            </a>
          </div>
        </div>
      </div>
    </footer>;
}